import {BifrostBackendApi} from "../gateways/BifrostBackendApi";

const OrderCorrespondenceProvider = {
	findAllByOrder(orderId) {
		return BifrostBackendApi.get("/order-correspondence", {
			params: {
				token: orderId
			}
		});
	},

	createNewMessageCustomer({ orderId, message, userConsent }) {
		return BifrostBackendApi.post("/order-correspondence", {
			message,
			sentBy: "customer",
			userConsent
		}, {
			params: {
				token: orderId
			}
		});
	},

	createNewMessageManager({ orderId, message }, jwtToken) {
		return BifrostBackendApi.post("/order-correspondence", {
			message,
			sentBy: "manager"
		}, {
			headers: { Authorization: jwtToken },
			params: {
				token: orderId
			}
		});
	},

	setOrderMessageAsRead({ orderId }, jwtToken) {
		return BifrostBackendApi.patch(`/order-correspondence/${orderId}`, {
			action: "setMessageAsRead"
		}, {
			headers: { Authorization: jwtToken },
			params: {
				token: orderId
			}
		});
	}
};

export default Object.freeze(OrderCorrespondenceProvider);
